import {
  Button as AntButton,
  Descriptions,
  Modal,
  Table,
  TableColumnsType,
} from 'antd';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAwardHistory } from '../../../../api/award.api';
import useAxios from '../../../../hooks/useAxios';
import { IGetAwardHistory } from '../../../../models/award.model';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  memberCode: string;
  classCode: string;
}

const AwardHistoryModal: FC<IProps> = ({
  visible,
  setVisible,
  memberCode,
  classCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetAwardHistory>();

  useEffect(() => {
    if (memberCode) {
      execute(getAwardHistory(memberCode, classCode));
    }
  }, [memberCode]);

  const columns: TableColumnsType<any> = [
    {
      title: t('class.class.column65'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
    },
    {
      title: t('class.class.column86'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
      sorter: (a, b) => a.courseName?.localeCompare(b.courseName),
    },
    {
      title: t('class.class.column57'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
      sorter: (a, b) => a.className?.localeCompare(b.className),
    },
    {
      title: 'Awards',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      sorter: (a, b) => a.name?.localeCompare(b.name),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('class.class.title16')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="cancel" className='btn-basic pink' onClick={() => setVisible(false)}>
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area rowType mt-0'>
          <Descriptions
            bordered
            column={2}
            size="small"
            labelStyle={{ width: '15%' }}
            contentStyle={{ width: '35%' }}
          >
            <Descriptions.Item label={t('class.class.column103')}>
              {res?.data?.courseName}
            </Descriptions.Item>
            <Descriptions.Item label={t('class.class.column104')}>
              {res?.data?.className}
            </Descriptions.Item>
            <Descriptions.Item label={t('class.class.column99')}>
              {res?.data?.memberName}
            </Descriptions.Item>
            <Descriptions.Item label={t('class.class.column26')}>
              {res?.data?.semesterName}
            </Descriptions.Item>
          </Descriptions>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res?.data?.awards}
            pagination={{
              pageSize: 9999999,
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default AwardHistoryModal;
